import { computed, ComputedRef, Ref, ref } from 'vue'

type SearchCb<T> = (el: T, search: string, searchByNumber: boolean) => boolean

interface Result<T> {
  search: Ref<string>;
  filtered: ComputedRef<Array<T>>;
  clear: () => void;
}

export function useSearch<T> (arr: Ref<Array<T>>, cb: SearchCb<T>): Result<T> {
  const search = ref<string>('')

  const searchByNumber = computed(() => {
    if (!search.value) return false

    return /^\d+$/.test(search.value)
  })

  const filtered = computed(() => {
    if (!search.value) return arr.value

    return arr.value.filter((el: T) => {
      if (!search.value) return true

      return cb(el, search.value, searchByNumber.value)
    })
  })

  const clear = () => {
    search.value = ''
  }

  return {
    search,
    filtered,
    clear,
  }
}
